import * as React from 'react';
import { BackNextSkip, TInvestmentReturn } from '@assetmark/common-elements/';
import { currencyFormatterWithDecimals } from '@assetmark/utilities/';
import {ProgressBarComponent} from '@assetmark/common-elements';
import styles from './investmentReturn.module.css';
import { TAssessRiskProfile, TAssessRiskProfileModule } from '../../models/assessRiskProfile.model';
import { TRiskChoice } from '../../models/TRiskChoice';
// import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { TQuestionData } from '../../models/riskQuestion.model';

export interface TInvestmentReturnProps {
  /** Array of Gain loss data */
  invesetmentRangeData: TAssessRiskProfileModule[];
  /** Total Investment Amount */
  investmentAmount: number;
  /** component data */
  data: TQuestionData;
  /** Next button click event handler */
  onNextButtonClick: (event: any, componentData: TQuestionData) => void;
  /** Back button click event handler */
  onBackButtonClick: (event: any, componentData: TQuestionData) => void;
  /** Skip button click event handler */
  onSkipButtonClick?: (event: any, componentData?: TQuestionData) => void;
}

export interface TInvestmentReturnState {
  data: TQuestionData;
}

export interface TInvestmentReturnRangeData {
  allSeries?: TInvestmentReturn[];
  seriesReturns: TInvestmentReturn;
}

export class InvestmentReturnComponent extends React.Component<
  TInvestmentReturnProps,
  TInvestmentReturnState
> {
  constructor(props?: TInvestmentReturnProps, context?: any) {
    super(props, context);

    // const riskDetails = this.props.risk.risk;
    this.state = {
      data: this.props.data,
    };
  }

  public componentDidMount() {
    // console.log('InvestmentReturnComponent Mount');
  }

  public UNSAFE_componentWillUpdate() {
    // console.log('InvestmentReturnComponent WillUpdate');
  }
  public componentWillUnmount() {
    // console.log('InvestmentReturnComponent Un-Mount');
  }

  public render() {
    // displaying models from helper
    if (!this.props) {
      return null;
    }

    const { selectedChoiceId, choices, heading, question } = this.state.data;
    const {
      investmentAmount,
      invesetmentRangeData,
      onBackButtonClick,
      onNextButtonClick,
    } = this.props;
    const investmentReturnModels = this.getInvestmentReturnModelsFromChoices(
      investmentAmount,
      invesetmentRangeData,
      choices,
    );

    const selected = selectedChoiceId ? selectedChoiceId : 0;

    return (
      <div className={`${styles.investmentReturnRangeComponent} col-sm-12`}>
        <h1 className={styles.investmentReturnRangeTitle}>{heading}</h1>
        <p className={styles.labelText}>
          {question.replace(
            '$amount',
            `$${currencyFormatterWithDecimals(investmentAmount)}`,
          )}
        </p>
        <div className="container-fluid mt-4">
          <div className={`row mt-row ${styles.returnBarCharts}`}>
            <div className={`col-sm-2 ${styles.initialInvestment}`}>
              <div className={styles.top}>
                <h3>INITIAL INVESTMENT</h3>
                <p>$ {currencyFormatterWithDecimals(investmentAmount)}</p>
              </div>
            </div>
            <div className="col-sm-10">
              <div className="row">
                {investmentReturnModels.map((model, index) => {
                  return (
                    <div
                      className={`col-2 ${styles.bar} ${
                        selected === model.Key ? styles.selected : ''
                      }`}
                      key={index}
                      onClick={() => this.onSelectInvestmentRange(model.Key)}
                    >
                      <ProgressBarComponent
                        height={340}
                        investmentAmount={investmentAmount}
                        allSeries={investmentReturnModels}
                        seriesReturns={model}
                        classTop={styles.top}
                        classBottom={styles.bottom}
                        classRect={styles.rect}
                        classDataLabel={styles.datalabel}
                      />
                      <a
                        onClick={() => this.onSelectInvestmentRange(model.Key)}
                        className={
                          selected === model.Key
                            ? `hidden ${styles.hiddenText} ${styles.selectReturnRange}`
                            : styles.selectReturnRange
                        }
                      >
                        Select
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <p className={styles.labelTextSmall}>
        * The returns displayed above reflect the high and low typical ranges
          of the rolling 12 month averages from January 1, 1990 through
          December 31, 2022 for six hypothetical portfolios of global stocks and
          bonds. These returns do not reflect the performance of actual
          investment accounts and are presented for illustrative purposes only.
          Past performance is not a guarantee of future results. Source: Zephyr
          StyleADVISOR, AssetMark.
        </p>
        <BackNextSkip
          backButtonClassName={`button button-secondary button-lg ${styles.btnLineHeight}`}
          backButtonText={'BACK'}
          onBackButtonClickHandler={(e) =>
            onBackButtonClick(e, this.state.data)
          }
          // nextButtonClassName={
          //   'button button-primary button-lg ml-2 ' +
          //   (selected && selected !== 0 ? '' : 'disabled')
          // }
          nextButtonClassName={`button button-primary button-lg ml-2 ${styles.btnLineHeight} ${selected && selected !== 0 ? '' : 'disabled'} ${selected && selected !== 0 ? '' : styles.btnDisabled}`}
          nextButtonText={'NEXT'}
          onNextButtonClickHandler={(e) =>
            onNextButtonClick(e, this.state.data)
          }
          isDisabledNextButton={(selected === 0) ? true : false}
          // skipText={"Assert Risk"}
          // onSkipClickHandler={this.props.onSkipButtonClick}
        />
      </div>
    );
  }

  private onSelectInvestmentRange = (barIndex: number): void => {
    const data = { ...this.state.data, selectedChoiceId: barIndex };
    this.setState({ data });
  };

  private getInvestmentReturnModelsFromChoices(
    investmentAmount: number,
    data: TAssessRiskProfileModule[],
    choices: TRiskChoice[],
  ) {
    if (!choices || choices.length === 0) {
      return [];
    }

    return data.map((ret, index) => {
      if (ret.gainLoss) {
        return {
          Key: choices[index] ? choices[index].choiceId : index,
          Gain: (investmentAmount * ret.gainLoss.gainPercent) / 100,
          GainPercent: ret.gainLoss.gainPercent,
          Loss: (investmentAmount * ret.gainLoss.lossPercent) / 100,
          LossPercent: ret.gainLoss.lossPercent,
          AverageReturn:
            (investmentAmount * ret.gainLoss.longTermAveragePercent) / 100,
          AverageReturnPercent: ret.gainLoss.longTermAveragePercent,
        };
      } else {
        return {
          Key: choices[index] ? choices[index].choiceId : index,
          Gain: investmentAmount / 100,
          GainPercent: 0,
          Loss: investmentAmount / 100,
          LossPercent: 0,
          AverageReturn: investmentAmount / 100,
          AverageReturnPercent: 0,
        };
      }
    });
  }
}

// InvestmentReturnComponent.defaultProps = {
//   barRangeSelected: false,
// };
